import {Route, Switch } from "react-router-dom";
import styled from "styled-components";
import TopBar from "../views/top-bar";
import OverviewScreen from "./overview-screen";
import AdminScreen from "./admin-screen";
import RecipeScreen from "./recipe-screen";
import PageOverviewScreen from "./page-overview-screen";
import CreatePageScreen from "./create-page-screen";
import BlogScreen from "./blog-screen";
import CreatePostScreen from "./create-post-screen";
import EditPostScreen from "./edit-post-screen";

const Content = styled.div`
  padding-top: 60px;
  width: 100%;
  max-width: 1000px;
  margin: auto;
`;

export default function MainApp() {
    return <>
        <TopBar />
        <Content>
            <Switch>
                <Route component={AdminScreen} path="/admin" />
                <Route component={RecipeScreen} path="/blogs/rezepte" />
                <Route component={CreatePostScreen} path="/blogs/:handle/new" />
                <Route component={EditPostScreen} path="/blogs/:handle/:id" />
                <Route component={BlogScreen} path="/blogs/:handle" />
                <Route component={CreatePageScreen} path="/pages/:handle/new" />
                <Route component={PageOverviewScreen} path="/pages/:handle" />
                <Route component={OverviewScreen} path="/" />
            </Switch>
        </Content>
    </>
}